<!-- Professional Terms of Use Page -->
<div class="legal-page">
  <!-- Header -->
  <header class="legal-header">
    <div class="header-content">
      <div class="logo-section">
        <div class="logo-icon">
          <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
            <polyline points="14 2 14 8 20 8"></polyline>
            <line x1="16" y1="13" x2="8" y2="13"></line>
            <line x1="16" y1="17" x2="8" y2="17"></line>
            <polyline points="10 9 9 9 8 9"></polyline>
          </svg>
        </div>
        <div class="logo-text">
          <span class="logo-title">Sofy</span>
          <span class="logo-subtitle">Conditions d'utilisation</span>
        </div>
      </div>
    </div>
  </header>

  <!-- Main Content -->
  <main class="legal-content">
    <div class="content-wrapper">
      <!-- Content from backend -->
      <div class="document-content" [innerHtml]="termsText"></div>
    </div>
  </main>

  <!-- Footer -->
  <footer class="legal-footer">
    <div class="footer-content">
      <div class="footer-brand">
        <strong>Logiciels INFO-DATA inc.</strong>
        <span>494 du Commodore, Lévis, QC, G7A 4Y8</span>
      </div>
      <div class="footer-copyright">
        &copy; {{ currentYear }} Logiciels INFO-DATA inc. Tous droits réservés.
      </div>
    </div>
  </footer>
</div>
